import { useState } from "react";
import { post } from "@common/api/apiShared";
import { Result } from "@common/api/result";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation.ts";
import { CreateApiKeyResultViewModel } from "../ApiKeys.types";
import { ICreateApiKeyDialogProps } from "./CreateApiKeyDialog";
import { isNullOrWhitespace } from "@common/stringOperations.ts";

export function useCreateApiKeyDialog(props: ICreateApiKeyDialogProps) {
    const [name, setName] = useState("");
    const [hasError, setHasError] = useState(false);
    const snackbar = useDotLegalSnackbar();
    const { translateString } = useTranslation();

    const saveMutation = useDotLegalMutation(save, {
        onSuccess: async (response: Result<CreateApiKeyResultViewModel>) => {
            if (!response.success()) {
                snackbar.show(translateString("apiKeyCreateFailed"), "warning");
                return;
            }
            snackbar.show(translateString("apiKeyCreated"));
            const result = response.value();
            await props.onCreated(result);
        },
    });

    function save() {
        return post<CreateApiKeyResultViewModel>("/api-keys", { name: name.trim() });
    }

    const createApiKey = async () => {
        if (isNullOrWhitespace(name)) {
            setHasError(true);
            return;
        }
        await saveMutation.mutateAsync();
    };

    return {
        name,
        setName,
        inProgress: saveMutation.isLoading,
        createApiKey,
        hasError,
    };
}
